import { forwardRef, type Ref, type SVGProps } from "react";
const IconDogLargeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.291 21.95c0 1.834-2.194 2.78-3.527 1.519l-2.343-2.216a1.944 1.944 0 1 0-2.716.122l-2.452 2.252c-1.355 1.245-3.544.284-3.544-1.556V10.85a7.26 7.26 0 0 1 2.124-5.144A7.27 7.27 0 0 1 16 3.56c2.02 0 3.847.82 5.167 2.147a7.27 7.27 0 0 1 2.124 5.144zm-9.883-9.673a1.296 1.296 0 1 1-2.593 0 1.296 1.296 0 0 1 2.593 0m6.48 1.296a1.296 1.296 0 1 0 0-2.592 1.296 1.296 0 0 0 0 2.592"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6.926 10.851v11.132h-1.96a2.965 2.965 0 0 1-2.925-3.451L3.945 7.06A2.965 2.965 0 0 1 6.87 4.58h2.572a9.04 9.04 0 0 0-2.516 6.271M13.46 24.94a3.83 3.83 0 0 1-2.302 1.022 6.04 6.04 0 0 0 4.874 2.47 6.04 6.04 0 0 0 4.956-2.585l-.033-.023a3.8 3.8 0 0 1-2.415-1.06l-2.41-2.28zm11.614-2.957V10.85a9.04 9.04 0 0 0-2.516-6.27h2.572a2.965 2.965 0 0 1 2.925 2.48l1.904 11.471a2.965 2.965 0 0 1-2.925 3.45z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconDogLargeFilledSVG);
ForwardRef.displayName = "IconDogLargeFilled";
export { ForwardRef as IconDogLargeFilled };
